module.exports = __webpack_public_path__ + "img/not-image.d162fc1c.svg";